import createIcon from '../../createIcon';

/**
 * @component @name Cases
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNlY0TDE2IDJIMTFMOSA0VjZINVYxN0M1IDE3IDYgMTkgNyAxOUgyMEMyMCAxOSAyMiAxOC4wMiAyMiAxN1Y2SDE4Wk00IDlIMlYyMEMyIDIxLjExIDIuODkgMjIgNCAyMkgxOEMxOS4xMSAyMiAyMCAyMS4xMSAyMCAyMEg0VjlaTTExIDVDMTEgNC40NSAxMS41MyA0IDEyIDRIMTVDMTUuNDYgNCAxNiA0LjU0IDE2IDVWNkgxMVY1Wk01IDZIMjJWMTdDMjIgMTguMSAyMS4xIDE5IDIwIDE5SDdDNS45IDE5IDUgMTguMSA1IDE3VjZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Cases = createIcon('Cases', [
  [
    'path',
    {
      d: 'M18 6V4L16 2H11L9 4V6H5V17C5 17 6 19 7 19H20C20 19 22 18.02 22 17V6H18ZM4 9H2V20C2 21.11 2.89 22 4 22H18C19.11 22 20 21.11 20 20H4V9ZM11 5C11 4.45 11.53 4 12 4H15C15.46 4 16 4.54 16 5V6H11V5ZM5 6H22V17C22 18.1 21.1 19 20 19H7C5.9 19 5 18.1 5 17V6Z',
      key: 'cfz24',
    },
  ],
]);

export default Cases;
